
import './Styles/Global.scss';
import Home from './Pages/Home';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Formulario from './Apps/Formulario/formulario';
import NavBar from './Components/NavBar/NavBar';
import { ArbolEnlace } from './Pages/Treelinks/TreeLinks';
import Sorteo from './Apps/Sorteo/Sorteo';
import Listado from './Apps/Listado/formulario';
import FormularioTienda from './Apps/FormularioTiendaNube/formulario';
import DiagnosticoTest from './Pages/Cuestionario/DiagnosticoTest';
import Captacion from './Pages/DemoEstudios/Captacion';
import SistemasPage from './Pages/Sistemas';
import CaptacionPage from './Pages/Captacion';
import DesarrolloWebPage from './Pages/DesarrolloWeb';


function App() {
  return (

    <Router>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sistemas" element={<SistemasPage />} />
        <Route path="/captacion" element={< CaptacionPage/>} />
        <Route path="/desarrolloweb" element={< DesarrolloWebPage/>} />
        <Route path="/appvoz" element={<Formulario/>} />
                <Route path="/formtienda" element={<FormularioTienda/>} />
        <Route path="/treelinks" element={<ArbolEnlace/>} />
        <Route path="/sorteo" element={<Sorteo/>} />
        <Route path="/listado" element={<Listado/>} />
        <Route path="/analisis" element={<DiagnosticoTest/>} />
        <Route path="/demo-estudios" element={<Captacion/>} />


      </Routes>
    </Router>

  );
}

export default App;
